import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SupplementaryEquipmentVisitComponent } from './component/supplementary-equipment/component/supplementary-equipment.component';
import { PersonalVisitDetailsDialogComponent } from './component/personal-visit-details-dialog/personal-visit-details-dialog.component';
import { PersonalVisitSearchComponent } from './personal-visit-search/personal-visit-search.component';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule, CommonUIModule, MasterDetailModule, ServiceResponseModule } from '@sdbn/common';
import { VisitMasterdataComponent } from './component/visit-masterdata/visit-masterdata.component';
import { VisitVisitedComponent } from './component/visit-visited/visit-visited.component';
import { VisitGroupComponent } from './component/visit-group/visit-group.component';
import { TMCTableModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';

import { VisitLogComponent } from './component/visit-log/visit-log.component';
import { VisitTasksComponent } from './component/visit-tasks/visit-tasks.component';
import { MatFormFieldModule as MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule as MatSelectModule } from '@angular/material/select';
import { MatTooltipModule as MatTooltipModule } from '@angular/material/tooltip';
import { MatTableModule as MatTableModule } from '@angular/material/table';
import { MatCheckboxModule as MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule as MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule as MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [
    PersonalVisitDetailsDialogComponent,
    PersonalVisitSearchComponent,
    SupplementaryEquipmentVisitComponent,
    VisitMasterdataComponent,
    VisitVisitedComponent,
    VisitGroupComponent,
    VisitLogComponent,
    VisitTasksComponent
  ],
  imports: [
    RouterModule,
    CommonModule,

    FormsModule,
    CommonTranslationModule,
    TMCTableModule,
    ReactiveFormsModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonUIModule,
    MasterDetailModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    MatTableModule,
    MatCheckboxModule,
    MatInputModule,
    MatSlideToggleModule,
    MatDialogModule
  ]
})
export class PersonalVisitModule { }
